<div class="case-feature-preview">
  <div class="case-feature-preview__toolbar" *ngIf="attachments().length">
    <ui-search
      class="case-feature-preview__search"
      [placeholder]="'CASES.FILES.SEARCH_FILENAME' | translate"
      [searchQuery]="searchTerm()"
      [heightPx]="40"
      (onInput)="searchTerm.set($event)"
    ></ui-search>
  </div>

  <div class="case-feature-preview__body">
    <div *ngIf="isLoading(); else filesContent" class="case-feature-preview__loader">
      <ui-preloader [color]="preloaderColor"></ui-preloader>
    </div>

    <ng-template #filesContent>
      <div *ngIf="filteredAttachments().length; else noFiles" class="case-feature-list">
        <div *ngFor="let attachment of filteredAttachments()" class="case-feature-card">
          <div class="case-feature-card__content">
            <div class="case-feature-card__header">
              <div class="case-feature-card__title" [title]="attachment.filename">
                <span class="ui-icon-file"></span>
                {{ attachment.filename }}
              </div>

              <div class="case-feature-card__actions">
                <ui-preloader
                  *ngIf="isBusy(attachment); else fileMenuTrigger"
                  [color]="preloaderColor"
                  [diameter]="18"
                ></ui-preloader>
                <ng-template #fileMenuTrigger>
                  <span
                    class="case-feature-card__menu-icon ui-icon-more-menu"
                    [matMenuTriggerFor]="fileMenu"
                  ></span>
                </ng-template>
              </div>

              <mat-menu #fileMenu="matMenu" xPosition="before">
                <button mat-menu-item type="button" (click)="requestEdit(attachment)">
                  {{ (canEdit() ? 'CASES.FILES.EDIT_LOCATION_AND_COMMENT' : 'CASES.FILES.VIEW_LOCATION_AND_COMMENT') | translate }}
                </button>
                <button *ngIf="canDownload()" mat-menu-item type="button" (click)="downloadAttachment(attachment)">
                  {{ 'COMMON.DOWNLOAD' | translate }}
                </button>
                <button *ngIf="canEdit()" mat-menu-item type="button" (click)="deleteAttachment(attachment)">
                  {{ 'COMMON.DELETE' | translate }}
                </button>
              </mat-menu>
            </div>

            <div class="case-feature-card__meta">
              <span class="ui-icon-time"></span>
              <span>{{ attachment.createdAt | date: 'MMM d, y, h:mm a' }}</span>
            </div>

            <div *ngIf="attachment.createdByName" class="case-feature-card__meta">
              <span class="ui-icon-user"></span>
              <span>{{ attachment.createdByName }}</span>
            </div>

            <div *ngIf="attachment.location?.address" class="case-feature-card__meta">
              <span class="ui-icon-map-view"></span>
              <span>{{ attachment.location?.address }}</span>
            </div>

            <div *ngIf="attachment.lastComment" class="case-feature-card__meta">
              <span class="ui-icon-comment"></span>
              <span>{{ attachment.lastComment }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #noFiles>
      <div class="case-feature-preview__empty">
        <span class="case-feature-preview__empty-icon ui-icon-file"></span>
        <div>{{ 'CASES.FILES.NO_DATA.TITLE' | translate }}</div>
      </div>
    </ng-template>
  </div>
</div>
